var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartdocumentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.74378243,8.53722614 L13.215339,7.14647274 C13.755296,7.03043464 14.2870851,7.37408885 14.4031232,7.91404589 C14.4319878,8.04836083 14.4328673,8.18718269 14.4057069,8.32185257 L13.0279911,15.1529868 C12.9484115,15.5475665 12.6400095,15.8559685 12.2454298,15.935548 L5.4661406,17.3028077 C4.92475666,17.411995 4.39736445,17.0616304 4.28817713,16.5202464 C4.25894913,16.3753251 4.26221759,16.225726 4.2977472,16.0822195 L5.98319571,9.27457902 C6.07502689,8.90366666 6.37020047,8.61750982 6.74378243,8.53722614 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-325.000000, -6231.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-16",
    transform: "translate(325.000000, 6231.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#D8D8D8",
    opacity: 0,
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\u77E9\\u5F62",
    fill: "#47B7FF",
    transform: "translate(9.312846, 12.220403) rotate(-315.000000) translate(-9.312846, -12.220403) ",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.57324232,4.82366954 L13.5904107,3.2045762 C14.1285563,3.08040816 14.6654677,3.41600333 14.7896357,3.95414898 C14.8240988,4.10351227 14.8237631,4.25879911 14.7886546,4.408012 L13.0966269,11.5992102 C13.008004,11.9758615 12.7100431,12.2675841 12.3316013,12.3482187 L5.37898453,13.829613 C4.838825,13.9447048 4.30763883,13.6001194 4.19254702,13.0599598 C4.16209129,12.9170222 4.16333598,12.7691462 4.19619347,12.6267415 L5.82366954,5.57324232 C5.90964748,5.20061299 6.20061299,4.90964748 6.57324232,4.82366954 Z",
    id: "\\u77E9\\u5F62",
    fill: "#2A7DFF",
    transform: "translate(9.500000, 8.500000) rotate(-315.000000) translate(-9.500000, -8.500000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartdocumentIcon);
export default __webpack_public_path__ + "static/media/Smartdocument_icon.033cd67e40e3e08edea813c0e36abc26.svg";
export { ForwardRef as ReactComponent };